import {
AlertOutlined,
ApartmentOutlined,
BarChartOutlined,
CalendarOutlined,
ClockCircleOutlined,
DashboardOutlined,
DollarOutlined,
FieldTimeOutlined,
FileExclamationOutlined,
FileTextOutlined,
FunnelPlotOutlined,
GiftOutlined,
HeatMapOutlined,
HourglassOutlined,
LineChartOutlined,
LoginOutlined,
PauseCircleOutlined,
PieChartOutlined,
RiseOutlined,
RollbackOutlined,
SafetyCertificateOutlined,
ShoppingOutlined,
StarOutlined,
StopOutlined,
SwapOutlined,
TeamOutlined,
TrophyOutlined,
UserAddOutlined,
UserDeleteOutlined,
WalletOutlined
} from "@ant-design/icons";
import React from "react";

/**
 * Symbol je iconKey aus dem reportsCatalog. Einzige Quelle für Auswertungs-Übersicht und
 * Gruppenseiten — sonst fehlt ein neuer Report-Schlüssel in genau einer der Ansichten und
 * bekommt dort still ein Ersatzsymbol.
 */
const iconByKey: Record<string, React.ReactNode> = {
  AlertOutlined: <AlertOutlined />,
  ApartmentOutlined: <ApartmentOutlined />,
  BarChartOutlined: <BarChartOutlined />,
  CalendarOutlined: <CalendarOutlined />,
  ClockCircleOutlined: <ClockCircleOutlined />,
  DashboardOutlined: <DashboardOutlined />,
  DollarOutlined: <DollarOutlined />,
  FieldTimeOutlined: <FieldTimeOutlined />,
  FileExclamationOutlined: <FileExclamationOutlined />,
  FileTextOutlined: <FileTextOutlined />,
  FunnelPlotOutlined: <FunnelPlotOutlined />,
  GiftOutlined: <GiftOutlined />,
  HeatMapOutlined: <HeatMapOutlined />,
  HourglassOutlined: <HourglassOutlined />,
  LineChartOutlined: <LineChartOutlined />,
  LoginOutlined: <LoginOutlined />,
  PauseCircleOutlined: <PauseCircleOutlined />,
  PieChartOutlined: <PieChartOutlined />,
  RiseOutlined: <RiseOutlined />,
  RollbackOutlined: <RollbackOutlined />,
  SafetyCertificateOutlined: <SafetyCertificateOutlined />,
  ShoppingOutlined: <ShoppingOutlined />,
  StarOutlined: <StarOutlined />,
  StopOutlined: <StopOutlined />,
  SwapOutlined: <SwapOutlined />,
  TeamOutlined: <TeamOutlined />,
  TrophyOutlined: <TrophyOutlined />,
  UserAddOutlined: <UserAddOutlined />,
  UserDeleteOutlined: <UserDeleteOutlined />,
  WalletOutlined: <WalletOutlined />
};

export function reportIcon(iconKey: string): React.ReactNode {
  return iconByKey[iconKey] || <BarChartOutlined />;
}
